import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';
import type { AppointmentFormData } from '../types/appointment';

export function useCreateAppointmentGlobal() {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ clientId, payload }: { clientId: string; payload: any }) => {
      if (!session?.access_token) {
        throw new Error('Session expired. Please log in again.');
      }
      return apiRequest(
        `/api/clients/${clientId}/appointments`,
        { method: 'POST', body: JSON.stringify(payload) },
        session.access_token
      );
    },
    onSuccess: () => {
      // Invalidate all appointment queries
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
    },
  });
}

export function useUpdateAppointmentGlobal() {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      clientId,
      appointmentId,
      payload,
    }: {
      clientId: string;
      appointmentId: string;
      payload: any;
    }) => {
      if (!session?.access_token) {
        throw new Error('Session expired. Please log in again.');
      }
      return apiRequest(
        `/api/clients/${clientId}/appointments/${appointmentId}`,
        { method: 'PATCH', body: JSON.stringify(payload) },
        session.access_token
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
    },
  });
}

export function useDeleteAppointmentGlobal() {
  const { session } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      clientId,
      appointmentId,
    }: {
      clientId: string;
      appointmentId: string;
    }) => {
      if (!session?.access_token) {
        throw new Error('Session expired. Please log in again.');
      }
      return apiRequest(
        `/api/clients/${clientId}/appointments/${appointmentId}`,
        { method: 'DELETE' },
        session.access_token
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['appointments'] });
    },
  });
}
